import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-booking-settings',
  templateUrl: './booking-settings.component.html',
  styleUrls: ['./booking-settings.component.css']
})
export class BookingSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
